export default __webpack_public_path__ + "static/media/cwc.f7a2edd2.svg";